module.exports = __webpack_public_path__ + "img/camion.858bd50b.png";